import { FieldDataType } from '../enums/FieldDataType';
import {
    ContactField,
    ContactFieldValue,
    CreateContactFieldsGroupedByValidationType,
} from './ContactField';
import { ContactOwner } from './ContactOwner';
import { ContactTag } from './ContactTag';

export interface Contact {
    contactId: number;
    clientId: number | undefined;
    hasConsent: boolean;
    firstName: string | undefined;
    lastName: string | undefined;
    statusId: number | null;
    status: string | null;
    values: ContactField[];
    tags: ContactTag[];
    owners: ContactOwner[];
    consent: ContactConsent | undefined;
}

export type CreateContactRequestValues = Pick<ContactField, 'fieldId' | 'value'>;

export interface CreateContactRequest {
    firstName: string;
    lastName: string;
    pPolicy: boolean;
    consent: boolean;
    terms: boolean;
    values: CreateContactRequestValues[];
}
export interface UpdateContactRequest {
    leadId: number;
    fieldType: FieldDataType;
    fieldId: number;
    value: string | ContactFieldValue;
}

export interface CreateContactFieldError {
    success: boolean;
    return: any;
    relatedId: number;
    error: string;
}

/**
 * buildCreateContact
 *
 * @description
 * Builds an object matching that expected by the server for a create new
 * contact request
 */
export function buildCreateContact(args: {
    firstName: string;
    lastName: string;
    pPolicy: boolean;
    consent: boolean;
    terms: boolean;
    values: CreateContactRequestValues[];
}): CreateContactRequest {
    return {
        firstName: args.firstName,
        lastName: args.lastName,
        pPolicy: args.pPolicy,
        consent: args.consent,
        terms: args.terms,
        values: args.values,
    };
}

export function buildUpdateContact(args: {
    leadId: number;
    fieldType: FieldDataType;
    fieldId: number;
    value: string | ContactFieldValue;
}): UpdateContactRequest {
    return {
        leadId: args.leadId,
        fieldType: args.fieldType,
        fieldId: args.fieldId,
        value: args.value,
    };
}

export declare type Contacts = {
    [contactId: number]: Contact;
};

export type CreateContactForm = CreateContactFieldsGroupedByValidationType & {
    firstName: string;
    lastName: string;
    pPolicy: boolean;
    consent: boolean;
    terms: boolean;
};

export const createContactFormInitialState: CreateContactForm = {
    firstName: '',
    lastName: '',
    pPolicy: false,
    consent: false,
    terms: false,
    address: [],
    date: [],
    dollar: [],
    email: [],
    other: [],
    none: [],
    phone: [],
    year: [],
};

export type ContactConsent = {
    expressConsent: boolean;
    impliedConsent: boolean;
    impliedConsentExpiry: string | undefined;
    smsConsent: boolean;
    emailConsent: boolean;
};

export interface ContactCallingDeepLinkResponse {
    clientId: number;
    userName: string;
    primaryPhone: string;
}
